import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";

export enum FolderTypes {
	Employee = 'employee'
}

export class Folder extends BaseModel {

	id: string
	parentId: string
    title: string
	info: string
	type: string
    fields: any

	public static getTitle(folder: Folder) {
		switch (folder.type) {
			case FolderTypes.Employee:
				return `${folder.fields? folder.fields.firstName : ''} ${folder.fields? folder.fields.lastName : ''}`
		}
		return folder.title
	}
}

